var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-typography',{attrs:{"bold":""}},[_vm._v(" 承認取消依頼の理由 ")]),_c('base-section-card',[_c('base-text-preformatted',{attrs:{"value":_vm.reason,"empty-text":"(理由なし)"}})],1),_c('base-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }